export const initialValues: { [key: string]: { [key: string]: any } } = {
  debtType: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  payableTo: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  originalAmount: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'number',
      required: true,
      min: 0,
    },
  },
  originationDate: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  presentBalance: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'number',
      required: true,
      min: 0,
    },
  },
  interestRate: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'number',
      required: true,
      min: 0,
      max: 100,
    },
  },
  maturityDate: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  monthlyPayment: {
    value: undefined,
    error: '',
    isTouched: false,
    rules: {
      type: 'number',
      required: true,
      min: 0,
    },
  },
};

export const debtTypes = ['1st Mortgage Holder', '2st Mortgage Holder', 'Other Building Lien'];
